import Ajv from 'ajv'

const ajv = new Ajv({allErrors: true})

export const validateSchema = (schema, value) => {
  let validate = ajv.compile(schema)
  var valid = validate(value)
  return {
    isValid: valid,
    errors: validate.errors
  }
}

export const makeDefaultItem = (schema = {}, isNestedRequire) => {
  let { properties, required } = schema
  if (!properties) return {}
  return Object.keys(properties).reduce((result, key) => {
    result[key] = properties[key].properties
      ? makeDefaultItem(properties[key], required && required.includes(key))
      // May be undefined, but we need to set the value to undefined in that case ;)
      : properties[key].default
    return result
  }, {
    '_include': isNestedRequire || undefined
  })
}



// WEBPACK FOOTER //
// ./client/src/util/jsonSchema.js